// @flow
import { ApolloClient } from "apollo-client"
import { createHttpLink } from "apollo-link-http"
import { from } from "apollo-link"
import config from "global/config"
import { purgePersistor } from "global/store"
import { resetAnalytics } from "analytics/index"
import { purgeTokens } from "./crypto"
import linkExtractTokens from "./linkExtractTokens"
import linkErrors from "./linkErrors"
import linkSetHeaders from "./linkSetHeaders"
import cache from "./cache"
import customFetch from "./customFetch"

const apolloClient = new ApolloClient({
  link: from([
    linkErrors,
    linkSetHeaders,
    linkExtractTokens,
    createHttpLink({ uri: config.api, fetch: customFetch }),
  ]),
  cache,
})

export const purgeEverything = (resetStore: boolean): Promise<void> => {
  purgeTokens()
  purgePersistor()
  resetAnalytics()

  return resetStore ? apolloClient.resetStore() : Promise.resolve()
}

export default apolloClient



// WEBPACK FOOTER //
// ./src/global/apolloClient/index.js